export enum SliderOptions {
	RESET = 'reset',
	FIT = 'fit',
	MINUS = 'minus',
	PLUS = 'plus'
}
